import { flow } from 'lodash';

export {
  createDefinition,
  ExtendableConfigGetter,
} from './lib/extendable-definition';

export const checkString = (
  searchedStr: string,
  str: string,
  forgiving = false
) => {
  str = str.replace(/[()]/g, '\\$&');
  const patten2 = str
    .split(' ')
    .map((x) => {
      return `(.*${x})`;
    })
    .join('');

  const pattern = str
    .split('')
    .map((x) => {
      return `(.*${x})`;
    })
    .join('');
  const regex = new RegExp(`${forgiving ? pattern : patten2}`, 'gi');
  const mateches = searchedStr.match(regex);
  return mateches ? mateches.length > 0 : false;
};

export type OptionWrapper<T> = {
  value: T;
  disabled: boolean;
};

type KeyValue<T> = { key: keyof T; value: T };

type KeyValues<T> = KeyValue<T>[];

type SmartDataInputs =
  | string
  | Blob
  | boolean
  | number
  | null
  | undefined
  | SmartDataInputs[];

export function toKeyValue<T extends Record<string, any>>(o: T): KeyValues<T> {
  return Object.keys(o).map((key) => ({ key, value: o[key] }));
}

function keyValueToFormDataInputs(
  keyValues: KeyValues<SmartDataInputs>
): KeyValues<string | Blob | (string | Blob)[]> {
  return keyValues.map((item) => {
    if (typeof item.value === 'boolean') {
      return { ...item, value: item.value ? 'true' : 'false' };
    }
    if (typeof item.value === 'number') {
      return { ...item, value: item.value.toString() };
    }
    if (Array.isArray(item)) {
      return keyValueToFormDataInputs(item);
    }
    if (!item.value) {
      return { ...item, value: '' };
    }
    return item;
  }) as KeyValues<string | Blob | (string | Blob)[]>;
}

function formDataKeyValueInputsToFormData(
  keyValues: KeyValues<string | Blob | (string | Blob)[]>
) {
  const formData = new FormData();

  keyValues.forEach(({ key, value }) => {
    if (!Array.isArray(value)) {
      formData.set(key, value);
      return;
    }
    value.forEach((value) => {
      formData.append(key, value);
    });
  });

  return formData;
}

// <Record<string, string>>

export const toFormData: (r: Record<string, SmartDataInputs>) => FormData =
  flow(toKeyValue, keyValueToFormDataInputs, formDataKeyValueInputsToFormData);

export * from './lib/role.helpers';

export * as StringHelpers from './lib/string.helpers';
export * as ClientHelpers from './lib/clients.helpers';
export * as PolicyHelpers from './lib/policies.helpers';
export * as FolderHelpers from './lib/folders.helpers';
export * as DateHelpers from './lib/date.helpers';
export * from './lib/experimental.helpers';
export * from './lib/dev-mode.helpers';
export { Connection, ConnectionStatus } from './lib/connection.helpers';
export {
  DynamicComponentDefinition,
  pipeDynamicComponentOutputs,
} from './lib/dynamic-component.helpers';
export { nanoid } from './lib/nanoid';
export * from './lib/partners.helpers';
export * from './lib/quote-permissions.helpers';
